var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-appointment-progress-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.title)?_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('ul',[_c('li',{class:{
                        'active': _vm.currentStep === 1,
                    }},[_vm._v("1. Mijn voertuig")]),_vm._v(" "),_c('li',{class:{
                        'active': _vm.currentStep === 2,
                    }},[_vm._v("2. Vestiging\n                    "),(!_vm.isRequestOffer)?[_vm._v("\n                        & datum\n                    ")]:_vm._e()],2),_vm._v(" "),_c('li',{class:{
                        'active': _vm.currentStep === 3,
                    }},[_vm._v("3. Services kiezen")]),_vm._v(" "),_c('li',{class:{
                        'active': _vm.currentStep === 4,
                    }},[_vm._v("4. Contactgegevens")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }